// extracted by mini-css-extract-plugin
module.exports = {"container":"Introductory_container__38Nvy","page":"Introductory_page__1eumi","section":"Introductory_section__2N33E"};